import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Alert from '../../components/Alert';

const Alerts = () => (
  <Row className="styles-section row" id="alerts">
    <Col xs={12}>
      <h3>Alerts &amp; Toasts</h3>
    </Col>
    <Col xs={12} sm={6}>
      <Row>
        <Col xs={12}>
          <h6>Styles</h6>
        </Col>
        <Col className="main-page-title" xs={12}>
          No Icon &amp; No Dismiss
        </Col>
        <Col xs={12}>
          <Alert>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>

        <Col className="main-page-title" xs={12}>
          Icon &amp; No Dismiss
        </Col>
        <Col xs={12}>
          <Alert variant="danger">
            <i className="icon fal fa-exclamation-circle"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>

        <Col className="main-page-title" xs={12}>
          Icon &amp; Dismissable
        </Col>
        <Col xs={12}>
          <Alert variant="danger" dismissible>
            <i className="icon fal fa-exclamation-circle"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>
      </Row>
    </Col>

    <Col xs={12} sm={6}>
      <Row>
        <Col xs={12}>
          <h6>Alert Types</h6>
        </Col>
        <Col className="main-page-title" xs={12}>
          General
        </Col>
        <Col xs={12}>
          <Alert>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>

        <Col className="main-page-title" xs={12}>
          Information
        </Col>
        <Col xs={12}>
          <Alert variant="info">
            <i className="icon fal fa-exclamation-circle"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>

        <Col className="main-page-title" xs={12}>
          Success
        </Col>
        <Col xs={12}>
          <Alert variant="success">
            <i className="icon fal fa-check-circle"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>

        <Col className="main-page-title" xs={12}>
          Warning
        </Col>
        <Col xs={12}>
          <Alert variant="warning">
            <i className="icon fal fa-exclamation-triangle"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>

        <Col className="main-page-title" xs={12}>
          Danger
        </Col>
        <Col xs={12}>
          <Alert variant="danger">
            <i className="icon fal fa-exclamation-circle"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
          </Alert>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default Alerts;